// extracted by mini-css-extract-plugin
export const root = "image-quote-module--root--A9eBC";
export const switchPos = "image-quote-module--switchPos--3ydON";
export const image = "image-quote-module--image---7M8M";
export const caption = "image-quote-module--caption--2OIxE";
export const quote = "image-quote-module--quote--2_oBR";